const faqs = [
    {
        question: "How long does a typical prototype take to build?",
        answer:
            "Most prototypes are delivered within 12-14 days after quotation approval, depending on complexity and manufacturing process. You can track the exact ETA on your project's progress bar.",
    },
    {
        question: "How is the AI cost estimate calculated?",
        answer:
            "Our AI Cost Estimator analyzes your uploaded CAD file, selected material, manufacturing process, and quantity to generate a live estimate covering material, machine hours, labour, and overheads.",
    },
    {
        question: "Can I change the manufacturing centre after submitting a request?",
        answer:
            "Yes, as long as the request hasn't moved past the Quotation stage. Reach out to your assigned expert or support to request a centre change.",
    },
    {
        question: "What file formats are supported for CAD upload?",
        answer:
            "We support STL, STEP, IGES, DWG, DXF, and PDF files, up to 500 MB per upload.",
    },
    {
        question: "How do I pay for an approved quotation?",
        answer:
            "Once a quotation is approved, go to Quotations or Orders and click Pay Now. We support UPI, cards, and net-banking.",
    },
    {
        question: "Who do I contact if my prototype is delayed?",
        answer:
            "You can message your assigned centre directly from the Messages tab, or raise a support ticket below and our team will follow up within 24 hours.",
    },
];

export default faqs;